import { ErrorCodes } from '@/Enums';
import { HttpError } from '@/scripts/Common/api';
import { ref, onUnmounted } from 'vue'

export const isAbortError = (error: unknown): boolean => {
  return  error instanceof DOMException && error.name === 'AbortError'
    || (error instanceof HttpError && error.problemDetails.type === ErrorCodes.client_request_aborted);
}

export const useAbortController = () => {
  const controller = ref<AbortController>()

  const getNewAbortController = () => {
    // Abort previous request if exists
    if (controller.value) {
      controller.value.abort()
    }
    // Create new controller
    controller.value = new AbortController()
    return controller.value
  }

  onUnmounted(() => {
    if (controller.value) {
      controller.value.abort()
    }
  })

  return {
    getNewAbortController,
    isAbortError
  }
}
